module.exports = __webpack_public_path__ + "57fe45f9.png";